import { fetchAuthSession } from "aws-amplify/auth";

export async function isAuthenticated() {
  try {
    const session = await fetchAuthSession();

    return !!session.tokens;
  } catch {
    return false;
  }
}
